$(function () {


    $('[js-schedule-remove]').on('click', function () {
        var NumberBtn = $(this).attr('js-schedule-remove');
        var NumberGroup = $(this).attr('js-group');
        $('[js-schedule-item]').each(function () {
            var $this = $(this);
            if ($this.attr('js-schedule-item') === NumberBtn) {
                $this.remove();
                $.post('/schedule/reserve/do/', {schedule_id: $this.data('id'), club_id: $this.data('club')}, function (data) {
                    if(data.trigger){
                        $(document).trigger(data.trigger);
                    }
                    if(data.alert){
                        $$.alert(data.alert);
                    }
                }, 'json');
            }
        });
        $('[js-group-items]').each(function () {
            if ($(this).attr('js-group-items') == NumberGroup) {
                var CheckLength = $(this).find('*').length;
                if (CheckLength == 0) {
                    $(this).html('<div class="schedule__section-alert"> Занятий нет</div>')
                }
            }
        })

    })
});